import { AccountConfigService } from './../../../../services/account-config/account-config.service';
import { Component, OnInit, Output, EventEmitter, Input, HostBinding } from '@angular/core';
import { MSelector, MSession } from '@argalis-apps/models';
import { SelectorService } from '../../../../services/selector/selector.service';
import { SessionService } from '../../../../services/session/session.service';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'ags-popup-presence',
  templateUrl: './popup-presence.component.html',
  styleUrls: ['./popup-presence.component.scss'],
  animations: [
    trigger('alertDisplay', [
      transition(':enter', [
        style({ transform: 'scale(0.8)', opacity: '0', height: '0' }),
        animate(100, style({ height: '100%' })),
        animate(300, style({ transform: 'scale(1)', opacity: '1' }))
      ]),
      transition(':leave', [
        animate(300, style({ transform: 'scale(0.5)', opacity: '0' })),
        animate(100, style({ height: '0' }))
      ])
    ])
  ]
})
export class PopupPresenceComponent implements OnInit {
  @HostBinding('class') themeFlag = 'account-theme';
  public checkRetard = false;
  public checkAbsence = false;
  public checkDepart = false;
  public absenceAllSession = false;
  public errorparams = false;
  public errorServer = false;
  public heureDepartAnticipeValue: Date;
  public heureRetardValue: Date;
  public motifAbsentId = null;
  private opened = true;
  public isDraggable = true;
  public listMotifAbsence: MSelector.IMotifAbsenceSelector[];
  public _presenceApprenantInfoChoosed: MSession.IPresence;
  public _presenceApprenantDataChoosed: MSession.ISessionApprenantPlanification;
  public idSessionApprenantPlannificationChoosed: number;
  public value = new Date();

  @Output() close = new EventEmitter();

  @Input()
  set presenceApprenantInfoChoosed(value: MSession.IPresence) {
    this._presenceApprenantInfoChoosed = value;
  }

  @Input()
  set presenceApprenantDataChoosed(value: any) {
    this._presenceApprenantDataChoosed = value;
  }

  constructor(
    private selectorService: SelectorService,
    private sessionService: SessionService,
    private accountConfigService: AccountConfigService
  ) {
    this.selectorService.getMotifAbsenceSelector().subscribe(res => {
      this.listMotifAbsence = res;
      this.motifAbsentId = this._presenceApprenantDataChoosed.id_motif_absence;
    });
  }

  ngOnInit() {
    this.themeFlag = `${this.themeFlag || ''} ${this.accountConfigService.themingClassName}`;
    this.checkRetard = this._presenceApprenantDataChoosed.b_retard;
    this.checkAbsence = !this._presenceApprenantDataChoosed.present;
    this.checkDepart = this._presenceApprenantDataChoosed.b_depart_anticipe;
    this.heureDepartAnticipeValue = this._presenceApprenantDataChoosed.heure_depart_anticipe
      ? new Date('1998-07-09T'.concat(this._presenceApprenantDataChoosed.heure_depart_anticipe))
      : null;
    this.heureRetardValue = this._presenceApprenantDataChoosed.heure_retard
      ? new Date('2019-07-09T'.concat(this._presenceApprenantDataChoosed.heure_retard))
      : null;
    this.idSessionApprenantPlannificationChoosed = this._presenceApprenantDataChoosed.id_session_apprenant_planification;
  }

  public changeAbsenceAllSession(value) {
    this.checkDepart = false;
    this.checkRetard = false;
    this.checkAbsence = value;
    this.absenceAllSession = value;
  }
  public closePop() {
    this.opened = false;
    this.close.emit(this.opened);
  }
  /* Permet de pouvoir cocher qu'une seule checkbox */
  public checkAll(option) {
    setTimeout(() => {
      /* Si Retard est coché on ne peut pas cocher les autres */
      if (option === 'checkRetard') {
        this.checkAbsence = false;
        this.checkDepart = false;
        this.absenceAllSession = false;
        /* Si Absence est coché on ne peut pas cocher les autres */
      } else if (option === 'checkAbsence') {
        this.checkRetard = false;
        this.checkDepart = false;
        /* Si Depart est coché on ne peut pas cocher les autres */
      } else if (option === 'checkDepart') {
        this.checkAbsence = false;
        this.checkRetard = false;
        this.absenceAllSession = false;
      }
    });
  }

  public getOption(value) {
    switch (value) {
      case 'abs':
        if (this.checkAbsence === true) {
          this.heureDepartAnticipeValue = null;
          this.checkDepart = null;
          this.heureRetardValue = null;
          this.checkRetard = null;
        } else if (this.checkRetard === true) {
          this.checkAbsence = false;
          this.heureDepartAnticipeValue = null;
          this.checkDepart = null;
        } else if (this.checkDepart === true) {
          this.checkAbsence = false;
          this.checkRetard = null;
          this.heureRetardValue = null;
        }
        if (!(this.checkAbsence && this.checkRetard && this.checkDepart)) {
          const requestBody: {
            b_present: boolean;
            b_retard: boolean;
            heure_retard: string;
            b_depart_anticipe: boolean;
            heure_depart_anticipe: string;
            id_session_apprenant_planification_list: number[];
            id_motif_abs: string;
          } = {
            b_present: !this.checkAbsence,
            b_retard: this.checkRetard,
            heure_retard: this.checkRetard ? this.heureRetardValue.toTimeString().split(' GMT')[0] : null,
            b_depart_anticipe: this.checkDepart,
            heure_depart_anticipe: this.checkDepart
              ? this.heureDepartAnticipeValue.toTimeString().split(' GMT')[0]
              : null,
            id_session_apprenant_planification_list: [],
            id_motif_abs: this.motifAbsentId
          };
          if (this.absenceAllSession) {
            requestBody.b_present = false;
            requestBody.id_session_apprenant_planification_list = this._presenceApprenantInfoChoosed.sessionApprenantPlanifications.map(
              info => info.id_session_apprenant_planification
            );
          } else {
            requestBody.id_session_apprenant_planification_list = [this.idSessionApprenantPlannificationChoosed];
          }
          this.updatePresenceInfo(requestBody);
        } else {
          this.errorparams = true;
        }
        break;
      case 'sup':
        const requestBody: {
          b_present: boolean;
          b_retard: boolean;
          heure_retard: string;
          b_depart_anticipe: boolean;
          heure_depart_anticipe: string;
          id_session_apprenant_planification_list: number[];
          id_motif_abs: string;
        } = {
          b_present: true,
          b_retard: null,
          heure_retard: null,
          b_depart_anticipe: null,
          heure_depart_anticipe: null,
          id_session_apprenant_planification_list: [this.idSessionApprenantPlannificationChoosed],
          id_motif_abs: null
        };
        this.updatePresenceInfo(requestBody);
    }
  }
  updatePresenceInfo(req) {
    this.sessionService.updatePresenceInfoBySession(req).subscribe(
      () => {
        this.closePop();
      },
      () => {
        this.errorServer = true;
      }
    );
  }
}
